import { map, compose, fromPairs, addIndex, __, assoc, omit, filter, complement, isNil } from 'ramda';
import { BookingStatus } from './status';

const ALPHABET = 'ABCDEFGHIJKLMOPQRSTUVWXZ';

const mapIndexed = addIndex(map);

export const createDatabaseEntry = ({ booking, experienceId, userId, payment, kiosk, kioskId, firstName, lastName }) =>
  filter(complement(isNil))({
    experienceId,
    status: BookingStatus.PENDING,
    user: userId,
    tickets: {
      date: booking.date,
      notes: booking.notes,
      types: map(assoc('ticketNumber', __, {}), booking.tickets),
      timeSlots: compose(
        fromPairs,
        mapIndexed((slot, index) => [ALPHABET[index], omit(['isActive'])(slot)])
      )(booking.timeSlots),
    },
    receiptId: payment.receiptId,
    paymentReference: payment.yourPaymentReference,
    isWebBooking: true,
    kiosk,
    kioskId,
    firstName,
    lastName,
  });
